import { render, staticRenderFns } from "./IconCalendarSolid.vue?vue&type=template&id=95c1379c"
import script from "./IconCalendarSolid.vue?vue&type=script&lang=js"
export * from "./IconCalendarSolid.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports